// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --bg-primary-Clr:#F25d2C;
    --bg-primary-clr:#1E4F6c;
    --text-primary-clr: #1E4F6c;
    --text-secondary-clr:#F25d2C;
    --text-black-Clr:#050505;
    --btn-primary-clr:#F25d2C;
   --primary-hover:#ff774a;
    --btn-secondary-clr:#1E4F6c;
    --btn-secondary-HOVER:#317ba5;
    --paragraph-font-size:15px;
    --heading1-size:4rem;
    --heading2-size:3rem;
  
  }



/* .LoginForm-item p,h1, h2, h3, h4, h5, h6{
    color: black;
} */

.input-name{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  gap: 5px;
}
.f-name{
    width: 65%;
    gap: 0px;
}
.l-name{
    width: 30%;
    gap: 0px;
}
.signup-wrapper {
    width: 100%;
    height: 100vh;
  }
  .signup-img img {
    width: 100%;
  }
  .signup-img {
    width: 40%;
  }
  .signup-page {
    width: 60%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-49%, -49%);
    padding: 50px 0;
    display: flex;

    border: 1px solid rgb(214, 214, 214);
    border-radius: 10px;
    justify-content: space-evenly;
    align-items: center;
    box-shadow: 0px 0px 4px -9px rgba(0, 0, 0, 0.045),
      0px 0px 11.1px -9px rgba(0, 0, 0, 0.065),
      0px 0px 26.8px -9px rgba(0, 0, 0, 0.085),
      0px 0px 89px -9px rgba(0, 0, 0, 0.13);
  }
  .signupForm-item {
    width: 50%;
    gap: 10px;
    padding: 10px;
    display: flex;
  }
  
  .email,
  .password,
  .signupForm-item {
    display: flex;
    flex-direction: column;
  }
  .signupForm-item input {
    width: 100%;
    height: 50px;
    padding: 0 15px;
    border-radius: 5px;
    border: 1px solid #dbdbdb;
    /* border: none; */
    outline: none;
  }
  

/* .LoginForm-item input:focus {
    border: 2px solid rgb(223, 223, 223);
  } */


.signup-button button{
    width: 100%;
    height: 40px;
    font-size: 16px;
    font-weight: 500;
   border-radius: 4px;
    background-color:var(--btn-primary-clr);
    color: white;
   border: none;
   cursor: pointer;
}
.signup-button button:hover{

    background-color:var(--primary-hover);
 
}
.signupForm-item label, .have-account p{
    font-size: 14px;
    font-weight: 500;
    color: #313131;
    
}
.form-control{
    margin-top: 20px;
}

.have-account{

    display: flex;
 
    justify-content: center;
    gap: 5px;
}

.have-account a{
    font-size: 14px;
    border: none;
    background: none;
    cursor: pointer;
    text-decoration: underline;
    color: var(--btn-primary-clr);
}

.have-account a:hover{
   color: var(--primary-hover);
}
.signupform-title{
    font-size: 40px;
    font-weight: 600;
    text-align: center;
    color: var(--btn-primary-clr);
}
.log-logo img{
width: 50%;
}
.log-logo {
 
    justify-content: center;
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Login_Signup/SignupformStyles.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,yBAAyB;GAC1B,uBAAuB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,0BAA0B;IAC1B,oBAAoB;IACpB,oBAAoB;;EAEtB;;;;AAIF;;GAEG;;AAEH;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;EACrB,QAAQ;AACV;AACA;IACI,UAAU;IACV,QAAQ;AACZ;AACA;IACI,UAAU;IACV,QAAQ;AACZ;AACA;IACI,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,aAAa;;IAEb,oCAAoC;IACpC,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB;;;2CAGuC;EACzC;EACA;IACE,UAAU;IACV,SAAS;IACT,aAAa;IACb,aAAa;EACf;;EAEA;;;IAGE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;;;AAGF;;KAEK;;;AAGL;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;GACjB,kBAAkB;IACjB,uCAAuC;IACvC,YAAY;GACb,YAAY;GACZ,eAAe;AAClB;AACA;;IAEI,qCAAqC;;AAEzC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;;AAElB;AACA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;;IAEb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;GACG,2BAA2B;AAC9B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;AACjC;AACA;AACA,UAAU;AACV;AACA;;IAEI,uBAAuB;IACvB,aAAa;AACjB","sourcesContent":[":root{\n    --bg-primary-Clr:#F25d2C;\n    --bg-primary-clr:#1E4F6c;\n    --text-primary-clr: #1E4F6c;\n    --text-secondary-clr:#F25d2C;\n    --text-black-Clr:#050505;\n    --btn-primary-clr:#F25d2C;\n   --primary-hover:#ff774a;\n    --btn-secondary-clr:#1E4F6c;\n    --btn-secondary-HOVER:#317ba5;\n    --paragraph-font-size:15px;\n    --heading1-size:4rem;\n    --heading2-size:3rem;\n  \n  }\n\n\n\n/* .LoginForm-item p,h1, h2, h3, h4, h5, h6{\n    color: black;\n} */\n\n.input-name{\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n  gap: 5px;\n}\n.f-name{\n    width: 65%;\n    gap: 0px;\n}\n.l-name{\n    width: 30%;\n    gap: 0px;\n}\n.signup-wrapper {\n    width: 100%;\n    height: 100vh;\n  }\n  .signup-img img {\n    width: 100%;\n  }\n  .signup-img {\n    width: 40%;\n  }\n  .signup-page {\n    width: 60%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-49%, -49%);\n    padding: 50px 0;\n    display: flex;\n\n    border: 1px solid rgb(214, 214, 214);\n    border-radius: 10px;\n    justify-content: space-evenly;\n    align-items: center;\n    box-shadow: 0px 0px 4px -9px rgba(0, 0, 0, 0.045),\n      0px 0px 11.1px -9px rgba(0, 0, 0, 0.065),\n      0px 0px 26.8px -9px rgba(0, 0, 0, 0.085),\n      0px 0px 89px -9px rgba(0, 0, 0, 0.13);\n  }\n  .signupForm-item {\n    width: 50%;\n    gap: 10px;\n    padding: 10px;\n    display: flex;\n  }\n  \n  .email,\n  .password,\n  .signupForm-item {\n    display: flex;\n    flex-direction: column;\n  }\n  .signupForm-item input {\n    width: 100%;\n    height: 50px;\n    padding: 0 15px;\n    border-radius: 5px;\n    border: 1px solid #dbdbdb;\n    /* border: none; */\n    outline: none;\n  }\n  \n\n/* .LoginForm-item input:focus {\n    border: 2px solid rgb(223, 223, 223);\n  } */\n\n\n.signup-button button{\n    width: 100%;\n    height: 40px;\n    font-size: 16px;\n    font-weight: 500;\n   border-radius: 4px;\n    background-color:var(--btn-primary-clr);\n    color: white;\n   border: none;\n   cursor: pointer;\n}\n.signup-button button:hover{\n\n    background-color:var(--primary-hover);\n \n}\n.signupForm-item label, .have-account p{\n    font-size: 14px;\n    font-weight: 500;\n    color: #313131;\n    \n}\n.form-control{\n    margin-top: 20px;\n}\n\n.have-account{\n\n    display: flex;\n \n    justify-content: center;\n    gap: 5px;\n}\n\n.have-account a{\n    font-size: 14px;\n    border: none;\n    background: none;\n    cursor: pointer;\n    text-decoration: underline;\n    color: var(--btn-primary-clr);\n}\n\n.have-account a:hover{\n   color: var(--primary-hover);\n}\n.signupform-title{\n    font-size: 40px;\n    font-weight: 600;\n    text-align: center;\n    color: var(--btn-primary-clr);\n}\n.log-logo img{\nwidth: 50%;\n}\n.log-logo {\n \n    justify-content: center;\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
